import { callApi } from "./fetch";
import { buildProductSubscribePayload } from "../utils/dashboardMappers";

function requireOrganisationId(organisationId: string): string {
  const orgId = organisationId.trim();
  if (!orgId) {
    throw new Error("Organisation not found in session.");
  }
  return orgId;
}

/** POST /organisations/:organisation_id/products/subscribe — one catalogue product at a time. */
export async function subscribeOrganisationProduct(
  organisationId: string,
  productId: string
) {
  const orgId = requireOrganisationId(organisationId);
  return callApi(`/organisations/${orgId}/products/subscribe`, {
    method: "POST",
    data: buildProductSubscribePayload(productId),
  });
}

/** POST /organisations/:organisation_id/products/unsubscribe — one catalogue product at a time. */
export async function unsubscribeOrganisationProduct(
  organisationId: string,
  productId: string
) {
  const orgId = requireOrganisationId(organisationId);
  return callApi(`/organisations/${orgId}/products/unsubscribe`, {
    method: "POST",
    data: buildProductSubscribePayload(productId),
  });
}
